import { useAuthMutation } from 'features/common/apiUtils/queryHelper';
import { useQueryClient } from 'react-query';
import { contextIdConfig } from '../config';
import { TUpsertContextProductPayload } from '../types/types';

const { upsert_context_product, get_contextid, get_context_resources } =
  contextIdConfig;

export const useUpsertContextProduct = ({
  sitecoreContextId,
}: {
  sitecoreContextId: string;
}) => {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance) => (payload: TUpsertContextProductPayload) =>
      axiosInstance?.put(
        upsert_context_product.url(sitecoreContextId),
        payload,
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          get_contextid.queryKey(sitecoreContextId),
        );
        queryClient.invalidateQueries(
          get_context_resources.queryKey(sitecoreContextId),
        );
      },
    },
    upsert_context_product.scope,
  );
};
